import { JetsonHealthDTO } from '../../types';
import { getDataWithRetry } from '../fetchUtils';
import { apiBaseUrl } from '../apiConsts';
import { isValidJetsonsHealthResponse } from '../apiValidators';

import type { FetchResult } from '../fetchUtils';

export const getJetsonsHealthByGymId = async (
  gymId: string,
): Promise<FetchResult<JetsonHealthDTO[]>> => {
  const response = await getDataWithRetry<JetsonHealthDTO[]>(
    `${apiBaseUrl}jetson-manager/health/${gymId}`,
    {},
    isValidJetsonsHealthResponse,
  );
  if (!response.success) {
    return response;
  }
  return {
    ...response,
    data: response.data ?? [],
  };
};
